import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';

import Config from '../../config.json';
import { useLessonContext } from '../../hooks';
import { useStudentInfo } from '../../hooks/lesson-player.context';
import { FeedbackRequestTypeName } from '../../interfaces/feedback-request-type.enum';
import { fetchPost } from '../../utils/fetch-utils';
import FeedbackDialog from '../feedback/feedback-dialog';
import ThemedText2 from '../themed-text-2';

interface AskATeacherProps {
  courseId?: number;
  visible: boolean;
  onClose: (bug?: string) => void;
}

export function AskATeacher({ courseId, visible, onClose }: AskATeacherProps) {
  const { environment } = useLessonContext();
  const studentInfo = useStudentInfo();
  const [postUrl, setPostUrl] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    setPostUrl(
      `${Config[environment].wolverineServiceUrl}/feedback/request/save`
    );
  }, [environment]);

  const nlsKeys = {
    title: 'talkNow.askTeacher',
    instructions: 'talkNow.questionInstructions',
    enterText: 'talkNow.enterQuestion',
    newQuestion: 'talkNow.newQuestion',
  };

  async function submit(question: string): Promise<Response> {
    const body = JSON.stringify({
      requestType: FeedbackRequestTypeName.ASK_A_TEACHER,
      courseId,
      question,
      personId: studentInfo?.id,
    });
    return fetchPost(postUrl, body);
  }

  return (
    <FeedbackDialog
      visible={visible}
      onClose={onClose}
      onSubmit={submit}
      nlsKeys={nlsKeys}
      successNode={
        <>
          <ThemedText2 style={styles.title}>
            {t('talkNow.question.thanks.title')}
          </ThemedText2>
          <ThemedText2 style={styles.text}>
            {t('talkNow.question.thanks.message')}
          </ThemedText2>
        </>
      }
    />
  );
}

const styles = StyleSheet.create({
  title: {
    marginVertical: 25,
    fontSize: 22,
    fontWeight: '600',
    textAlign: 'center',
  },
  text: {
    textAlign: 'center',
  },
});
